import React from 'react';
import cn from 'classnames';
import PT from 'prop-types';

import CloseSVG from 'Components/Admin/assets/CloseSVG';

import Modal from 'Components/Modal/Modal';
import Button from 'Components/Admin/Button';

const AdminModal = ({
                      title,
                      children,
                      renderCustomFooter,
                      extraButtons = [],
                      successBtn,
                      onClose,
                      onSuccess,
                      className,
                      testId = '',
                      direction = 'middle',
                    }) => {
  return (
    <Modal>
      <div className="admin-modal__container admin-page" data-testid={testId}>
        <div className="admin-modal__overlay" />
        <div className={cn('admin-modal', `admin-modal_${direction}`, className)}>
          <div className="admin-modal__header">
            {title}
            <div className="admin-modal__close" onClick={onClose}><CloseSVG /></div>
          </div>
          <div className="admin-modal__body">{children}</div>
          <div className="admin-modal__footer">
            {
              renderCustomFooter
                ? renderCustomFooter({ onSuccess, onClose })
                : (
                  <>
                    <Button className="admin-modal__btn_cancel admin-modal__btn" variant="secondary" onClick={onClose}>
                      Cancel
                    </Button>
                    <div className="admin-modal__btn-group">
                      {
                        extraButtons.length
                          ? extraButtons.map((btn, index) => <React.Fragment key={index}>{btn}</React.Fragment>)
                          : null
                      }
                      <div onClick={onSuccess}>
                        {successBtn || (
                          <Button className="admin-modal__btn" variant="primary">
                            Save Changes
                          </Button>
                        )}
                      </div>
                    </div>
                  </>
                )
            }
          </div>
        </div>
      </div>
    </Modal>
  );
};

AdminModal.propTypes = {
  title: PT.string,
  children: PT.any,
  customFooter: PT.element,
  successBtn: PT.element,
  onClose: PT.func,
  onSuccess: PT.func,
  className: PT.string,
  testId: PT.string,
  direction: PT.oneOf(['top', 'middle', 'bottom']),
};

export default AdminModal;
